// Types
import {
  LengthType,
  MeasurementType,
  PressureType,
  TemperatureType,
  TimeUnitType,
} from '../../../types/global';

export enum SeriesColorEnum {
  purple = 'purple',
  yellow = 'yellow',
  lightOrange = 'lightOrange',
  green = 'green',
  orange = 'orange',
  blue = 'blue',
  pink = 'pink',
  lightGreen = 'lightGreen',
  lightPink = 'lightPink',
  lightBlue = 'lightBlue',
}

export type BarChartTheme = {
  colors: {
    barSeriesColor: {
      purple: string;
      yellow: string;
      lightOrange: string;
      green: string;
      orange: string;
      blue: string;
      pink: string;
      lightGreen: string;
      lightPink: string;
      lightBlue: string;
    };
  };
};

export type SeriesColor = string | SeriesColorEnum;

export type Series = {
  color?: SeriesColor;
  decimals?: number;
  field: string;
  name: string;
  unit?: TimeUnitType | TemperatureType | PressureType | LengthType;
  measurementType?: MeasurementType;
  yAxisMax?: number;
  yAxisMin?: number;
};

export interface BarChartProps {
  className?: string;
  data: Record<string, any>[];
  id: string;
  series: Series[];
  testId?: string;
}
